var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.detailsInfo != null
    ? _c("div", { staticClass: "theme_details_wrap" }, [
        _c("div", { staticClass: "theme_details_stem" }, [
          _c("div", { staticClass: "theme_details_stem_title" }, [
            _vm.detailsInfo.roofPlacement
              ? _c("span", [_vm._v("顶")])
              : _vm._e(),
            _vm._v(" "),
            _c("h2", {
              domProps: {
                innerHTML: _vm._s(
                  _vm.$replace.replaceMark(_vm.detailsInfo.theme)
                )
              }
            })
          ]),
          _vm._v(" "),
          _c("div", {
            staticClass: "theme_details_stem_content ql-editor",
            domProps: { innerHTML: _vm._s(_vm.detailsInfo.content) }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "theme_details_stem_info" }, [
            _c("div", { staticClass: "theme_details_stem_info_left" }, [
              _c("div", { staticClass: "left_box" }, [
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm.detailsInfo.anonymous == 1
                        ? _vm.detailsInfo.userName
                        : "匿名用户"
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "left_box" }, [
                _c("p", [_vm._v(_vm._s(_vm.detailsInfo.createTimeStr))])
              ]),
              _vm._v(" "),
              _vm.detailsInfo.discussionAreaId != 3
                ? _c("div", { staticClass: "left_box" }, [
                    _c("img", {
                      attrs: {
                        src: require("../../../../../../../static/images/study/icon/zhangjie.png")
                      }
                    }),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.detailsInfo.catalogName &&
                            _vm.detailsInfo.catalogName != null
                            ? _vm.detailsInfo.catalogName
                            : "全部教学章节"
                        )
                      )
                    ])
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "theme_details_stem_info_right" }, [
              _c("ol", [
                _c(
                  "li",
                  {
                    class: _vm.detailsInfo.isSameQuestion
                      ? "same_question_ck"
                      : "",
                    on: {
                      click: function($event) {
                        return _vm.sameQuestion(_vm.detailsInfo)
                      }
                    }
                  },
                  [
                    _c("span", [_vm._v("同问")]),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.detailsInfo.sameQuestionNum &&
                            _vm.detailsInfo.sameQuestionNum != null
                            ? _vm.detailsInfo.sameQuestionNum
                            : 0
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    class: _vm.detailsInfo.isPraise ? "praise_ck" : "",
                    on: {
                      click: function($event) {
                        return _vm.likedDiscuss(_vm.detailsInfo)
                      }
                    }
                  },
                  [
                    _c("i"),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.detailsInfo.praiseCount &&
                            _vm.detailsInfo.praiseCount != null
                            ? _vm.detailsInfo.praiseCount
                            : 0
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm.detailsInfo.isCreateUser
                  ? _c("li", { staticClass: "edit_discuss" }, [
                      _c("i", {
                        on: {
                          click: function($event) {
                            return _vm.editDiscuss(_vm.detailsInfo)
                          }
                        }
                      })
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.detailsInfo.isCreateUser || _vm.detailsInfo.isClassTeacher
                  ? _c("li", { staticClass: "delete_discuss" }, [
                      _c("i", {
                        on: {
                          click: function($event) {
                            return _vm.deleteDiscuss(_vm.detailsInfo)
                          }
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ])
          ]),
          _vm._v(" "),
          _vm.detailsInfo.repliedOrParticipation
            ? _c("div", { staticClass: "discuss_status" }, [
                _c("p", [
                  _vm._v(_vm._s(_vm.detailsInfo.repliedOrParticipationName))
                ])
              ])
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "reply_area_wrap" },
          [
            _c("el-input", {
              staticClass: "reply_area",
              attrs: {
                type: "textarea",
                placeholder: "欢迎留言交流",
                maxlength: "300",
                "show-word-limit": ""
              },
              model: {
                value: _vm.replyValue,
                callback: function($$v) {
                  _vm.replyValue = $$v
                },
                expression: "replyValue"
              }
            }),
            _vm._v(" "),
            !_vm.isShowAnonymous
              ? _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.isAnonymousReply,
                      callback: function($$v) {
                        _vm.isAnonymousReply = $$v
                      },
                      expression: "isAnonymousReply"
                    }
                  },
                  [_vm._v("匿名发表")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "el-button",
              {
                attrs: { disabled: _vm.isReply },
                on: {
                  click: function($event) {
                    return _vm.publishReply(_vm.detailsInfo)
                  }
                }
              },
              [_vm._v("发表留言")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "reply_area_list" }, [
          _c("div", { staticClass: "reply_num" }, [
            _c("span", [_vm._v("全部回复")]),
            _vm._v(" "),
            _c("span", [
              _vm._v(_vm._s(_vm.replyList ? _vm.replyList.length : 0))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "reply_list" }, [
            _vm.replyList.length > 0
              ? _c(
                  "ul",
                  _vm._l(_vm.replyList, function(item, key) {
                    return _c(
                      "li",
                      { key: key, staticClass: "reply_list_lis" },
                      [
                        _c("div", { staticClass: "reply_list_title" }, [
                          item.deleteFlag == 1
                            ? _c("p", [_vm._v("该回复已删除")])
                            : _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(item.discussionContent)
                                }
                              })
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "reply_list_footer" }, [
                          _c("div", { staticClass: "reply_list_left" }, [
                            _c("span", { staticClass: "reply_name" }, [
                              _vm._v(
                                _vm._s(
                                  item.anonymous == 1
                                    ? item.userName
                                    : "匿名用户"
                                )
                              )
                            ]),
                            _vm._v(" "),
                            item.userType == 0 || item.userType == 1
                              ? _c("span", { staticClass: "reply_type" }, [
                                  _vm._v("教师")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", { staticClass: "reply_time" }, [
                              _vm._v(_vm._s(item.replyTimeStr))
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "reply_list_right" }, [
                            _c("ol", [
                              _c(
                                "li",
                                {
                                  class: item.isPraise
                                    ? "reply_liked_ck"
                                    : "reply_liked",
                                  on: {
                                    click: function($event) {
                                      return _vm.replyLiked(item)
                                    }
                                  }
                                },
                                [
                                  _c("i"),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        item.praiseCount == null
                                          ? 0
                                          : item.praiseCount
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "li",
                                {
                                  staticClass: "reply_comment",
                                  on: {
                                    click: function($event) {
                                      return _vm.replyComment(item)
                                    }
                                  }
                                },
                                [
                                  _c("i"),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(item.replyNum))])
                                ]
                              ),
                              _vm._v(" "),
                              item.deleteFlag == 0 &&
                              (item.isCreateUser || item.teacherFlag)
                                ? _c(
                                    "li",
                                    {
                                      staticClass: "reply_delete",
                                      on: {
                                        click: function($event) {
                                          return _vm.replyDelete(item)
                                        }
                                      }
                                    },
                                    [_c("i")]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { class: "comment_list_wrap " + item.className },
                          [
                            item.deleteFlag == 0
                              ? _c(
                                  "div",
                                  { staticClass: "comment_area_wrap" },
                                  [
                                    _c("el-input", {
                                      staticClass: "comment_area",
                                      attrs: {
                                        type: "textarea",
                                        placeholder: "我来说几句",
                                        maxlength: "300",
                                        "show-word-limit": ""
                                      },
                                      nativeOn: {
                                        keyup: function($event) {
                                          return _vm.editComment(item)
                                        }
                                      },
                                      model: {
                                        value: item.commentValue,
                                        callback: function($$v) {
                                          _vm.$set(item, "commentValue", $$v)
                                        },
                                        expression: "item.commentValue"
                                      }
                                    }),
                                    _vm._v(" "),
                                    !_vm.isShowAnonymous
                                      ? _c(
                                          "el-checkbox",
                                          {
                                            model: {
                                              value: item.anonymousValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  item,
                                                  "anonymousValue",
                                                  $$v
                                                )
                                              },
                                              expression: "item.anonymousValue"
                                            }
                                          },
                                          [_vm._v("匿名发表")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          disabled:
                                            item.commentValue &&
                                            item.commentValue.trim() != ""
                                              ? false
                                              : true
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.publishComment(item)
                                          }
                                        }
                                      },
                                      [_vm._v("发表评论")]
                                    ),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticStyle: {
                                        clear: "both",
                                        "border-bottom": "1px solid #E6E6E6"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("div", { staticClass: "comment_list" }, [
                              _c(
                                "ul",
                                _vm._l(item.pinglunList, function(v, i) {
                                  return _c(
                                    "li",
                                    { key: i, staticClass: "comment_list_lis" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "comment_list_title" },
                                        [
                                          _c("p", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                v.discussionContent
                                              )
                                            }
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "comment_list_footer" },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "comment_list_left"
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "comment_name" },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      v.anonymous == 1
                                                        ? v.userName
                                                        : "匿名用户"
                                                    )
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              v.userType == 0 || v.userType == 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "comment_type"
                                                    },
                                                    [_vm._v("教师")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "span",
                                                { staticClass: "comment_time" },
                                                [_vm._v(_vm._s(v.replyTimeStr))]
                                              )
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "comment_list_right"
                                            },
                                            [
                                              _c("ol", [
                                                _c(
                                                  "li",
                                                  {
                                                    class: v.isPraise
                                                      ? "comment_liked_ck"
                                                      : "comment_liked",
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.likedComment(
                                                          v
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _c("i"),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(v.praiseCount)
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                v.isCreateUser || v.teacherFlag
                                                  ? _c(
                                                      "li",
                                                      {
                                                        staticClass:
                                                          "comment_delete",
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            return _vm.deleteComment(
                                                              v,
                                                              item
                                                            )
                                                          }
                                                        }
                                                      },
                                                      [_c("i")]
                                                    )
                                                  : _vm._e()
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                }),
                                0
                              )
                            ])
                          ]
                        )
                      ]
                    )
                  }),
                  0
                )
              : _c("div", { staticClass: "no_reply_list" }, [
                  _c("img", {
                    attrs: {
                      src: require("../../../../../../../static/images/wujieguo.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("暂无回复")])
                ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76395a7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76395a7a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/studyCenter/switch/discuss/component/themeDetails.vue
// module id = null
// module chunks = 